"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _react = require("react");

var _reactRouter = require("react-router");

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CardLink = function CardLink(_ref) {
  var children = _ref.children,
      slug = _ref.slug,
      other = _objectWithoutProperties(_ref, ["children", "slug"]);

  var isEmbedded = "".concat((0, _lodash.get)(window, "location.origin", ""), "/cards/").concat(slug, "/embed/") === (0, _lodash.get)(window, "location.href", "") || "".concat((0, _lodash.get)(window, "location.origin", ""), "/cards/").concat(slug, "/embed/visualization") === (0, _lodash.get)(window, "location.href", "");
  return (0, _core.jsx)(_react.Fragment, null, isEmbedded ? (0, _core.jsx)(_reactRouter.Link, _extends({
    target: "_blank",
    to: "".concat((0, _lodash.get)(window, "location.origin"), "/cards/").concat(slug)
  }, other), (0, _core.jsx)("span", null, children)) : (0, _core.jsx)(_reactRouter.Link, _extends({
    to: "".concat((0, _lodash.get)(window, "location.origin"), "/cards/").concat(slug)
  }, other), (0, _core.jsx)("span", null, children)));
};

CardLink.displayName = "CardLink";
CardLink.propTypes = {
  children: _propTypes["default"].node,
  slug: _propTypes["default"].string
};
var _default = CardLink;
exports["default"] = _default;